import Image from "next/image";

import Airplane from "@/public/svg/destinations/hand-picked/airplane.svg";
import Building from "@/public/svg/destinations/hand-picked/building.svg";
import LocationIcon from "@/public/svg/destinations/hand-picked/location.svg";
import Ranking from "@/public/svg/destinations/hand-picked/ranking.svg";
import Borderline from "@/public/svg/destinations/hand-picked/vector-line.svg";

import Heading from "@/components/heading/heading";
import Button from "@/components/button/Button";

import "./ticket-card.scss";

interface TourCardProps {
    name: string;
    picture: any;
    location: string;
    
    price: string;

    listvertical: {
        icon: string;
        title: string;
    }[];
    list: {
        icon: string;
        title: string;
    }[];
    trends: {
        title: string;
        color: string;
    }[];
    
    mostbook: {
        title: string;
        color: string;
    }[];
}

const TicketCard = (props: TourCardProps) => {
    const h = props;
    return (
        <a href="#" className="flex ticket-card card relative">
            <figure>
                <Image loading="lazy" src={h.picture} alt={h.name} />
            </figure>
            <ul className="tag-list flex flex-wrap absolute top-2 items-center gap-3">
                            {h.mostbook.map((t, index) => (
                                <li
                                    className="flex tag-list-item rounded-e-lg py-2 px-3"
                                    key={index}
                                    style={{ backgroundColor: t.color }}
                                >
                                    <span className="font-medium color-white">
                                        {t.title}
                                    </span>
                                </li>
                            ))}
            </ul>

            <div className="ticket-card-info flex flex-col justify-between gap-4 px-4 py-6">
                <div className="ticket-card-details flex flex-col gap-4">
                    <div className="flex mb-grid mb-reverse justify-between">
                        <Heading as="h3" className="max-width-30 max-width-38 mb-bottom">
                            {h.name}
                        </Heading>
                        <ul className="tag-list flex flex-wrap items-center gap-3">
                            {h.trends.map((t, index) => (
                                <li
                                    className="flex tag-list-item py-2 px-3"
                                    key={index}
                                    style={{ backgroundColor: t.color }}
                                >
                                    <span className="font-medium">
                                        {t.title}
                                    </span>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="ticket-card-location flex items-center gap-2">
                        <div className="flex items-center gap-1">
                            <Image
                                loading="lazy"
                                src={LocationIcon}
                                alt="location"
                            />
                            <span className="font-medium text-lg">
                                {h.location}
                            </span>
                        </div>
                        {/* <span className="ticket-card-place dot">{h.place}</span> */}
                    </div>

                    <ul className="option-list contents items-center  gap-y-4">
                        {h.listvertical.map((item, index) => (
                            <li
                                key={index}
                                className="option-list-item  dot flex items-center gap-1"
                            >
                                <Image
                                    loading="lazy"
                                    src={item.icon}
                                    alt={item.title}
                                />

                                <span className=" font-medium text-sm">
                                    {item.title}
                                </span>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="ticket-card-bottom flex mb-grid items-center justify-between pt-4">
                    <ul className="option-list flex flex-wrap items-center gap-5">
                        {h.list.map((item, index) => (
                            <li
                                key={index}
                                className="option-list-item flex items-center gap-1"
                            >
                                <Image
                                    loading="lazy"
                                    src={item.icon}
                                    alt={item.title}
                                />
                                <span className="color-grey font-medium text-sm">
                                    {item.title}
                                </span>
                            </li>
                        ))}
                    </ul>

                    <Image
                        loading="lazy"
                        className="mb-none"
                        src={Borderline}
                        alt={""}
                    />
                    <div className="price-person flex mb-margin-top mb-none flex-col gap-0">
                            <div className="price flex mb-margin-top items-center gap-3">
                                <span className="font-medium text-lg price-text">
                                    Starting from
                                </span>
                            </div>
                            <div className="person flex mb-margin-top-1 items-center gap-2">
                                <strong>
                                    {h.price} <span>/ Person</span>
                                </strong>
                            </div>
                            <span className="color-grey font-medium">
                                (Min 3pax)
                            </span>
                        </div>

                        <Button
                            className="flex-center mb-none mb-margin-top"
                            variant="orange"
                        >
                            <span>Get Quote</span>
                        </Button>
                    <div className="mb-flex desktop-none mb-block">
                        <div className="price-person flex mb-margin-top flex-col gap-0">
                            <div className="price flex mb-margin-top items-center gap-3">
                                <span className="font-medium text-lg price-text">
                                    Starting from
                                </span>
                            </div>
                            <div className="person flex mb-margin-top-1 items-center gap-2">
                                <strong>
                                    {h.price} <span>/ Person</span>
                                </strong>
                            </div>
                            <span className="color-grey font-medium">
                                (Min 3pax)
                            </span>
                        </div>

                        <Button
                            className="flex-center  mb-margin-top"
                            variant="orange"
                        >
                            <span>Get Quote</span>
                        </Button>
                    </div>
                </div>
            </div>
        </a>
    );
};

export default TicketCard;
